export default class BadGateway extends Error {
  constructor(message) {
    super(message);
    this.name = 'BadGateway';
  }
}
